import { InjectionToken } from '@angular/core';
import { GeolocationPlugin, Geolocation } from '@capacitor/geolocation';

export const GEOLOCATION_TOKEN = new InjectionToken<GeolocationPlugin>('Geolocation');

export function provideGeolocation() {
  return {
    provide: GEOLOCATION_TOKEN,
    useValue: Geolocation,
  };
}
